export class GetMissedAlertsDto {
    assetIds: number[];
  }